module.exports = __webpack_public_path__ + "img/violet_076.243a94b6.png";